module.exports = __webpack_public_path__ + "static/media/29-mercedes.1119d47a.jpg";